import React, { useEffect, useRef, useState } from 'react';
import { compressFiles, optimizeFormData, validateFormData } from '../../../shared/utils/performanceUtils';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaSave, FaArrowLeft } from 'react-icons/fa';
import { AiOutlineProduct } from 'react-icons/ai';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';
import {
  updateProducts,
  productsRecord,
  clearState,
  fetchStoreProfile,
} from '../../../redux/Slices/ProductsSlice';
import axios from 'axios';
import "./products.css";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const EditProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [imagePreviews, setImagePreviews] = useState([]);
  const [allImages, setAllImages] = useState([]);
  const fileInputRef = useRef(null);

  const [unitsData, setUnitsData] = useState([
    {
      unit_name: "",
      price: "",
      quantity: "",
      colors: [],
    },
  ]);
  const [units, setUnits] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    quantity: "",
    subcategory_id: "",
    images: [],
    units: [],
    description: "",
    image_url: "",
  });

  const { isLoading, error, success, storeProfile, record } =
    useSelector((state) => state.products);

  useEffect(() => {
    dispatch(clearState());
    dispatch(fetchStoreProfile());
    fetchUnitsFromApi();
  }, [dispatch]);

  const getAuthToken = () => {
    try {
      const s = sessionStorage.getItem('storekhadamat');
      if (!s) return null;
      const parsed = JSON.parse(s);
      return parsed?.token || null;
    } catch { return null; }
  };

  const fetchUnitsFromApi = async () => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${BASE_URL}/category_unit`, {
        headers: { 'Authorization': `Bearer ${token}`, 'Accept-Language': 'ar', 'lang': 'ar' }
      });
      const list = res.data?.data || res.data?.result || [];
      setUnits(Array.isArray(list) ? list : []);
    } catch (e) {
      showErrorToast('فشل في جلب الوحدات');
    }
  };
  useEffect(() => {
    dispatch(clearState());
    if (id) {
      dispatch(productsRecord(id));
    }
  }, [dispatch, id]);
  useEffect(() => {
    if (record) {
      setFormData({
        name: record?.name || "",
        price: record?.price || "",
        quantity: record?.quantity || "",
        units: [],
        description: record?.description || "",
        image_url:
          record?.image_url ||
          record?.first_image_url ||
          "",
        images: [],
      });

      if (record?.images) {
        setAllImages(
          record.images.map((img) => ({
            id: img.id,
            image_url: img.image_url,
            isNew: false,
            file: null,
            toDelete: false,
          }))
        );
      }
      if (record.units && record.units.length > 0) {
        setUnitsData(
          record.units.map((unit) => ({
            id: unit.id, // unique key
            unit_name: String(unit.unit_name || unit.unit_id || ""),
            price: unit.price || "",
            quantity: unit.quantity || "",
            colors:
              unit.colors?.map((c) => ({
              id: c.id,
                color_code: c.color_code || "",
              price: c.price || "",
              quantity: c.quantity || "",
              })) || [],
          }))
        );
      }
    }
  }, [record]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "image_url") {
      const trimmed = value.trim();
      setFormData((prev) => ({
        ...prev,
        image_url: value,
        images: trimmed ? [] : prev.images,
      }));
      if (trimmed) {
        setAllImages((prev) => {
          prev.forEach((img) => {
            if (img.isNew && img.image_url?.startsWith("blob:")) {
              URL.revokeObjectURL(img.image_url);
            }
          });
          return [];
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleColorChange = (unitIndex, colorIndex, e) => {
    const { name, value } = e.target;
    setUnitsData((prev) => {
      const updated = [...prev];
      updated[unitIndex].colors[colorIndex][name] = value;
      return updated;
    });
  };
  const handleUnitChange = (unitIndex, e) => {
    const { name, value } = e.target;
    setUnitsData((prev) => {
      const updated = [...prev];
      updated[unitIndex][name] = value;
      return updated;
    });
  };
  const handleAddUnit = () => {
    setUnitsData((prev) => [
      ...prev,
      {
        unit_name: "",
        price: "",
        quantity: "",
        colors: [],
      },
    ]);
  };

  const handleRemoveUnit = (index) => {
    setUnitsData((prev) => prev.filter((_, i) => i !== index));
  };

  // Add new empty row
  const handleAddColor = (unitIndex) => {
    setUnitsData((prev) => {
      const updated = [...prev];
      updated[unitIndex].colors.push({
        color_code: "#000000",
        price: "",
        quantity: "",
      });
      return updated;
    });
  };

  const handleRemoveColor = (unitIndex, colorIndex) => {
    setUnitsData((prev) => {
      const updated = [...prev];
      updated[unitIndex].colors = updated[unitIndex].colors.filter(
        (_, i) => i !== colorIndex
      );
      return updated;
    });
  };

  const hasUnitData = unitsData.some((unit) =>
    unit.colors.some((c) => c.color_code || c.price || c.quantity)
  );
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    for (let file of files) {
      if (!validTypes.includes(file.type)) {
        showErrorToast("الملفات يجب أن تكون صور (jpg, jpeg, png)");
        e.target.value = "";
        return;
      }
    }

    const newImages = files.map((file) => ({
      id: null,
      image_url: URL.createObjectURL(file),
      isNew: true,
      file,
      toDelete: false,
    }));

    setFormData((prev) => ({ ...prev, image_url: "" }));
    setAllImages((prev) => [...prev, ...newImages]);
  };

  useEffect(() => {
    return () => {
      imagePreviews.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [imagePreviews]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(clearState());

    // Build unitsPayload
    const unitsPayload = unitsData.map((unit) => {
      const selectedUnit = units.find((u) => u.id === Number(unit.unit_name));

      const colorsPayload =
        unit.colors && unit.colors.length > 0
          ? unit.colors
              .filter(
                (c) =>
                  (c.color_code && c.color_code.trim() !== '') ||
                  (c.price !== undefined && c.price !== null && c.price !== '') ||
                  (c.quantity !== undefined && c.quantity !== null && c.quantity !== '')
              )
              .map((c) => ({
                color_code:
                  c.color_code && c.color_code.trim() !== ''
                    ? c.color_code.trim()
                    : '#000000',
                price:
                  c.price !== undefined && c.price !== null && c.price !== ''
                    ? c.price
                    : unit.price || formData.price,
                quantity:
                  c.quantity !== undefined && c.quantity !== null && c.quantity !== ''
                    ? c.quantity
                    : unit.quantity || formData.quantity,
              }))
          : [];

      return {
        unit_type: selectedUnit?.type || "",
        unit_name: unit.unit_name,
        price: unit.price || formData.price,
        quantity: unit.quantity || formData.quantity,
        colors: colorsPayload,
      };
    });

    const fd = new FormData();
    fd.append("name", formData.name);
    fd.append(
      "subcategory_id",
      storeProfile?.subcategory_id || record?.subcategory_id
    );
    fd.append("price", formData.price);
    fd.append("description", formData.description);
    const imageUrlTrimmed = String(formData.image_url || "").trim();
    if (imageUrlTrimmed) {
      fd.append("image_url", imageUrlTrimmed);
    }

    // الصور: أرسل فقط الصور الجديدة (ملفات) واترك الصور القديمة كما هي
    let newImageIdx = 0;
    allImages.forEach((img) => {
      if (!img.toDelete && img.isNew && img.file) {
        fd.append(`images[${newImageIdx}]`, img.file);
        newImageIdx += 1;
      }
    });

    // وحدات
    unitsPayload.forEach((unit, unitIndex) => {
      fd.append(`units[${unitIndex}][unit_type]`, unit.unit_type);
      fd.append(`units[${unitIndex}][unit_name]`, unit.unit_name);
      fd.append(`units[${unitIndex}][price]`, unit.price);
      fd.append(`units[${unitIndex}][quantity]`, unit.quantity);

      unit.colors.forEach((color, colorIndex) => {
        fd.append(
          `units[${unitIndex}][colors][${colorIndex}][color_code]`,
          color.color_code
        );
        fd.append(
          `units[${unitIndex}][colors][${colorIndex}][price]`,
          color.price
        );
        fd.append(
          `units[${unitIndex}][colors][${colorIndex}][quantity]`,
          color.quantity
        );
      });
    });

    dispatch(updateProducts({ id, formData: fd }));
  };

  useEffect(() => {
    if (success) {
      showSuccessToast("تم التحديث بنجاح");
      dispatch(clearState());
      navigate("/view-products");
    }
    if (error && record) {
      showErrorToast("لم يتم التحديث");
      dispatch(clearState());
    }
  }, [success, error, dispatch, navigate]);
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              {" "}
              <h4 style={{ fontSize: "1.1rem", margin: 0 }}>
                {" "}
                <AiOutlineProduct
                  className="mx-2"
                  style={{ fontSize: "1.5rem", color: "#6b7280" }}
                />{" "}
                تعديل منتج
              </h4>
            </div>
            <div>
              <Link to="/view-products" className="text-decoration-none mx-3">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="btn btn-outline-secondary btn-sm"
                  style={{ borderRadius: "8px" }}
                >
                  العودة
                  <FaArrowLeft className="mx-2" />
                </motion.button>
              </Link>
            </div>
          </div>

          <div className="card p-3">
            {!id ? (
              <div className="text-center text-danger">لا يوجد معرف (ID)</div>
            ) : isLoading ? (
              <div className="text-sm">جاري التحميل...</div>
            ) : !record ? (
              <div className="text-center text-danger">المنتج غير موجود</div>
            ) : (
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="name" className="form-label">
                        الاسم *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="الاسم"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="price" className="form-label">
                        السعر
                      </label>
                      <input
                        type="number"
                        min="1"
                        step="1"
                        className="form-control"
                        id="price"
                        name="price"
                        value={formData.price}
                        onChange={handleInputChange}
                        placeholder="السعر"
                        required={!hasUnitData}
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label htmlFor="quantity" className="form-label">
                        الكمية *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="quantity"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleInputChange}
                        placeholder="الكمية"
                        required
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label htmlFor="description" className="form-label">
                        الوصف *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="الوصف"
                        required
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label htmlFor="image_url" className="form-label">
                        رابط صورة (اختياري)
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        id="image_url"
                        name="image_url"
                        value={formData.image_url}
                        onChange={handleInputChange}
                        placeholder="https://..."
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label htmlFor="images" className="form-label">
                        صور (اختياري)
                      </label>
                      <input
                        type="file"
                        multiple
                        className="form-control"
                        accept="image/png, image/jpeg, image/jpg"
                        id="images"
                        name="images"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />

                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {allImages.map((img, idx) => (
                          <div key={idx} className="position-relative">
                            <img
                              src={img.image_url}
                              alt="product"
                              className="img-thumbnail"
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute top-0 end-0"
                              onClick={async () => {
                                if (img.id) {
                                  try {
                                    const user = JSON.parse(
                                      sessionStorage.getItem("storekhadamat")
                                    );
                                    const token = user?.token;

                                    await fetch(
                                      `${process.env.REACT_APP_BASE_URL}/products/delete_product_image`,
                                      {
                                        method: "POST",
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                          "Content-Type": "application/json",
                                        },
                                        body: JSON.stringify({
                                          image_id: img.id,
                                        }),
                                      }
                                    );

                                    showSuccessToast("تم حذف الصورة بنجاح");

                                    setAllImages((prev) => {
                                      const updated = prev.filter(
                                        (_, i) => i !== idx
                                      );
                                      if (
                                        updated.length === 0 &&
                                        fileInputRef.current
                                      ) {
                                        fileInputRef.current.value = "";
                                        setFormData((p) => ({
                                          ...p,
                                          images: [],
                                        }));
                                      }
                                      return updated;
                                    });
                                  } catch (error) {
                                    showErrorToast("فشل حذف الصورة");
                                  }
                                } else {
                                  setAllImages((prev) => {
                                    const updated = prev.filter(
                                      (_, i) => i !== idx
                                    );
                                    if (
                                      updated.length === 0 &&
                                      fileInputRef.current
                                    ) {
                                      fileInputRef.current.value = "";
                                      setFormData((p) => ({
                                        ...p,
                                        images: [],
                                      }));
                                    }
                                    return updated;
                                  });
                                }
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>

                    {unitsData.map((unit, unitIndex) => (
                      <div
                        key={unit.id || `unit-${unitIndex}`}
                        className="border p-3 mb-3 rounded bg-light"
                      >
                        <h6>الوحدة {unitIndex + 1}</h6>

                        {/* Select unit */}
                        <select
                          name="unit_name"
                          value={unit.unit_name || ""}
                          onChange={(e) => handleUnitChange(unitIndex, e)}
                          className="form-select mb-2"
                          required
                        >
                          <option value="" disabled>
                            اختر الوحدة
                          </option>
                          {units.map((u) => (
                            <option key={u.id} value={u.id}>
                              {u.name}
                            </option>
                          ))}
                        </select>

                        <input
                          type="number"
                          min="1"
                          step="1"
                          name="price"
                          value={unit.price || ""}
                          onChange={(e) => handleUnitChange(unitIndex, e)}
                          placeholder="السعر"
                          className="form-control mb-2"
                        />
                        <input
                          name="quantity"
                          value={unit.quantity || ""}
                          onChange={(e) => handleUnitChange(unitIndex, e)}
                          placeholder="الكمية"
                          className="form-control mb-2"
                        />

                        {/* Colors */}
                        {unit.colors.map((color, colorIndex) => (
                          <div
                            key={color.id || `color-${unitIndex}-${colorIndex}`}
                            className="d-flex gap-2 mb-2"
                          >
                            <span className="mt-1">اللون</span>
                            <input
                              type="color"
                              name="color_code"
                              className="mt-1"
                              value={color.color_code || "#000000"}
                              onChange={(e) =>
                                handleColorChange(unitIndex, colorIndex, e)
                              }
                            />
                            <input
                              type="number"
                              min="1"
                              step="1"
                              name="price"
                              value={color.price || ""}
                              onChange={(e) =>
                                handleColorChange(unitIndex, colorIndex, e)
                              }
                              placeholder="سعر اللون"
                              className="form-control"
                            />
                            <input
                              name="quantity"
                              value={color?.quantity || ""}
                              onChange={(e) =>
                                handleColorChange(unitIndex, colorIndex, e)
                              }
                              placeholder="كمية اللون"
                              className="form-control"
                            />
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() =>
                                handleRemoveColor(unitIndex, colorIndex)
                              }
                            >
                              -
                            </button>
                            {colorIndex === unit.colors.length - 1 && (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => handleAddColor(unitIndex)}
                              >
                                +
                              </button>
                            )}
                          </div>
                        ))}

                        <div className="d-flex justify-content-end gap-2 flex-wrap mt-3">
                          {unit.colors.length === 0 && (
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm px-3"
                              onClick={() => handleAddColor(unitIndex)}
                            >
                              + إضافة لون
                            </button>
                          )}
                        <button
                          type="button"
                            className="btn btn-outline-danger btn-sm px-3"
                          onClick={() => handleRemoveUnit(unitIndex)}
                        >
                          حذف الوحدة
                        </button>
                        </div>
                      </div>
                    ))}

                    <button
                      type="button"
                      style={{ fontSize: "small" }}
                      className="btn btn-outline-primary"
                      onClick={handleAddUnit}
                    >
                      + إضافة وحدة
                    </button>
                  </div>

                  <div className="d-flex justify-content-end gap-2 mt-4">
                    <motion.button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigate("/view-products")}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      إلغاء
                    </motion.button>
                    <motion.button
                      type="submit"
                      className="btn btn-primary d-flex align-items-center"
                      disabled={isLoading}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm mx-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          جاري الحفظ...
                        </>
                      ) : (
                        <>
                          <FaSave className="mx-2" />
                          حفظ
                        </>
                      )}
                    </motion.button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
